/**
 * Whether a key press is typed into a field (an input, a text area, a select,
 * or editable text) rather than meant for the editor. The editor's own keys,
 * undo and redo and the 3D camera's, leave such a press to the field.
 */
export const isTypingInField = (event: KeyboardEvent): boolean =>
  !!(event.target as HTMLElement | null)?.closest?.('input, textarea, select, [contenteditable=true]');
